import { SigningMethod } from '../../enums/const-enums';
import { ReduxAction } from '../../enums/const-enums';

export interface MethodState {
  activeSignMethod?: SigningMethod;
  activeSignMethodStatus?: string;
  allowedSignMethods: Array<SigningMethod>;
  preferredSignMethod: SigningMethod;
}

const initialState: MethodState = {
  activeSignMethod: null,
  activeSignMethodStatus: null,
  allowedSignMethods: [SigningMethod.RABO_SCANNER, SigningMethod.RANDOM_READER],
  preferredSignMethod: null,
};

export interface MethodAction {
  type: ReduxAction;
  payload: MethodState;
}

export function methodReducer(
  state: MethodState = initialState,
  action: MethodAction,
): MethodState {
  switch (action.type) {
    case ReduxAction.INIT_METHODS:
      state.allowedSignMethods = action.payload.allowedSignMethods;
      state.preferredSignMethod = action.payload.preferredSignMethod;
      break;
    case ReduxAction.SET_ACTIVE_METHOD:
      state.activeSignMethod = action.payload.activeSignMethod;
      state.activeSignMethodStatus = null;
      break;
    case ReduxAction.SET_ACTIVE_METHOD_STATUS:
      state.activeSignMethodStatus = action.payload.activeSignMethodStatus;
      break;
    case ReduxAction.SET_ALLOWED_METHODS:
      state.allowedSignMethods = action.payload.allowedSignMethods;
      break;
    case ReduxAction.SET_PREFERRED_METHOD:
      state.preferredSignMethod = action.payload.preferredSignMethod;
      break;
  }
  return state;
}
